<template>
  <button
    :class="['btn', 'btn-' + color, btnBlock, disabled]"
    :type="type"
    @click="$emit('click', $event)">
    <slot v-if="!loading"></slot>
    <span v-if="loading">{{ loadingText }}</span>
  </button>
</template>

<script>
export default {
  name: "form-button",
  props: {
    type: {
      type: String,
      default: "button",
      validate: val => {
        return ["button", "submit", "reset"].indexOf(val) !== -1;
      }
    },
    color: {
      type: String,
      default: "default"
    },
    block: {
      type: Boolean,
      default: false
    },
    loadingText: {
      type: String,
      default: "Aguarde..."
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    disabled() {
      return this.loading === true ? "disabled" : "";
    },
    btnBlock() {
      return this.block ? "btn-block" : "";
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/UIComponents/Buttons/FormButton.vue